module.exports = __webpack_public_path__ + "static/media/rober6.49d3541f.jpg";